export const BOLD_REGEX = /\*(.*?)\*/g;
export const cueListAsHTML = (cues) => {
    if (!cues) {
        return null;
    }
    const wrapper = document.createElement('div');
    for (let i = 0, len = cues.length; i < len; i++) {
        const cue = cues[i];
        wrapper.append(cue.getCueAsHTML());
    }
    return wrapper.innerHTML.replace(BOLD_REGEX, '<strong>$1</strong>');
};
//# sourceMappingURL=video.js.map